import { config } from "../../../../frontend.config";

export const localization: LocalizationConfig = {
    available: config.locales,

    locales: {
        en: {
            fonts: {
                primaryFont: "Bangers",
                secondaryFont: "Montserrat",
            },
        },
    },
};
